import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/api.js'
import Util from '@/utils.js'
import kjutils from '@/kj_utils.js'
import VueSocketIO from 'vue-socket.io'

import { Indicator } from 'mint-ui';
Vue.use(Vuex)

const state = {
    opentime: 3,
    app_url:'https://baike.baidu.com/item/%E5%B9%BF%E5%8F%91%E8%AF%81%E5%88%B8%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/2643135?fromtitle=%E5%B9%BF%E5%8F%91%E8%AF%81%E5%88%B8&fromid=2458789&fr=aladdin',
    phone: "",
    token: "",
    appname: "",
    showgong: true,
    gonggao2: "",
    chongzhi2kefu: false,
    label2:"部分合作伙伴",
    image2url:"static/hezuohuoban.png",

    zhangfubang: [{
        "name": "POWR",
        "volume": 760000,
        "cnc_price": 0.66,
        "btc_price": 0.00001076,
        "ratio": 0.4423
    }],
    market_list: [
        { name: "BTC/USDT", price: 8772.84, ratio: 0.004 }
    ],
    about_url:'',
    imagelist: [],
    tickers: [],
    currentCode: "hsbs",
    logo_header: "",
    login_logo: "",
    online_service_url: '',
    imageurl: '',
    gonggao: '',
    user: null,
    show_dongjie: true,
    tx_info: "",
    product_lists: [],
    auth:false,

    zhuban: {},
    chuangxin: {
         "hsbs": {
            "c1": "hsbs",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
        "barclays": {
            "c1": "barclays",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
        "tesco": {
            "c1": "tesco",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
        "hbv": {
            "c1": "hbv",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
        "dpt": {
            "c1": "dpt",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
        "ipv": {
            "c1": "ipv",
            "c2": "cny",
            "price": 160.3194444444441,
            "upradio": 0.031187732825088868,
            "vol": 40881.45833333324,
            "type": "小币种"
        },
       
    },

    currencylist: {},
    expect: "",
    miao: 0,
    windata: { totalvalue: 0, totalwin: 0 },
    prolist: [],

}

const mutations = {

    SOCKET_message(state, msg) {
        //console.log(msg);
        state.currencylist = msg;
        let d1 = {}
        let d2 = {}
        let c;
        for (let i in msg) {
            c = msg[i]
            if (c.type == '官方币') {
                d1[c.c1] = c;
            } else {
                d2[c.c1] = c;
            }
        }
        state.zhuban = d1;
        state.chuangxin = d2;


    },

    setTickers(state, obj) {
        state.tickers = obj.data;

    },
    setUser(state, obj) {
        state.user = obj;
    },
    setWinData(state, obj) {
        state.windata = obj;
    },
    setProlist(state, obj) {
        state.prolist = obj;
    },
    setConfig(state, obj) {
        state.gonggao = obj.gonggao;
        state.online_service_url = obj.online_service_url;
        state.imageurl = obj.imageurl;
        state.imagelist = obj.imagelist;
        state.opentime = obj.opentime;
        state.product_lists = obj.product_lists;
        state.gonggao2 = obj.gonggao2;
        state.login_logo = obj.login_logo
        state.logo_header = obj.logo_header;
        state.appname = obj.appname;
        state.showgong = true;
        state.about_url = obj.about_url;
        state.chongzhi2kefu = obj.chongzhi2kefu;
        state.show_dongjie = obj.is_show_dongjie;
        state.tx_info = obj.tx_info;
        if(obj.image2url)state.image2url =obj.image2url;
        if(obj.label2)state.label2 = obj.label2;
        //window.initApp();
        window.$store.dispatch("initApp")
    },
    updateResult(state, obj) {
        setTimeout(() => {
            this.dispatch("getUserInfo")
            this.dispatch("getGameResult", { "expect": obj.expect })
        }, 10000)
    },


}
const actions = {

    initAppConfig({ commit, state }) {
        Api.getAppUrl().then((res) => {

            loading.innertHmtl = "";
            loading.style.display = "none"
            window.host_url = res.data[0];
            window.chat_url = res.data[1];
            console.log(host_url);
            Api.setHostUrl(host_url);


            Vue.use(new VueSocketIO({
                debug: true,
                connection: chat_url,
                vuex: {
                    store: $store,
                    actionPrefix: 'SOCKET_',
                    mutationPrefix: 'SOCKET_'
                },
                options: { secure: true, transports: ['websocket'] }
            }));

            $store.dispatch("getTickers")
            $store.dispatch("getConfig")
            $store.dispatch("getProlist")
        })
    },

    initApp({ commit, state }) {
        //let did=Util.getDeviceId();
        let token = Util.getToken();

        window.token = token;
        if (token) {
            this.dispatch("getUserInfo");
        } else {
            window.$router.push("/login");
        }
        this.dispatch("startTimer");

    },


    startTimer({ commit, state }) {
        setInterval(() => {

            let cp = kjutils.cp("" + state.opentime);

            state.expect = cp[0];
            state.miao = cp[1];
            if (cp[1].toFixed(0) == 5) {
                this.commit("updateResult", { expect: cp[0] })
            }

        }, 1000)
    },

    getConfig({ commit, state }) {
        Api.getConfig().then((res) => {
            commit("setConfig", res.data);
        });
        Api.getServerTime().then((res) => {
            var t = res.data['time'] * 1000;
            timeoffset = t - moment().utcOffset(8).valueOf();
        });
    },
    getProlist({ commit, state }) {
        Api.getProlist().then((res) => {
            commit("setProlist", res.data);
        })
    },
    getTickers({ commit, state }) {
        Api.getTickers().then((res) => {
            commit("setTickers", res.data)
        })
    },
    getGameResult({ commit, state }, obj) {
        Api.getGameResult(obj.expect).then((res) => {
            window.showResult(res.data);
        });
    },
    getUserInfo({ commit, state }, showloading) {

        if (showloading) {
            Indicator.open({
                text: '',
                spinnerType: 'fading-circle'
            });
        }


        Api.getUserInfo().then(res => {
            Indicator.close();
            commit("setUser", res.data.user)

            if (res.data.windata.length > 0) {
                commit("setWinData", res.data.windata[0])
            }
            if (!res.data.user.active) {
                window.$vue.toast("您的账号已被冻结,请联系在线客服")
                window.$router.push("/login");
            }


        }).catch(e => {

            Indicator.close();
            window.$router.push("/login");

        })
    }
}

const getters = {

}



export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js